import { render } from "./GameWithoutCourse.vue?vue&type=template&id=6f4357e0&scoped=true"
import script from "./GameWithoutCourse.vue?vue&type=script&lang=js"
export * from "./GameWithoutCourse.vue?vue&type=script&lang=js"

import "./GameWithoutCourse.vue?vue&type=style&index=0&id=6f4357e0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4357e0"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading});
